import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateHTMLComponent } from "../../templates/template-html/template-html.component";

@Component({
  selector: "app-prefix-xpr",
  imports: [TemplateHTMLComponent],
  templateUrl: "./prefix-xpr.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-xpr.component.less",
})
export class PrefixXprComponent extends PrefixComponent<string> {
  public constructor() {
    super();
    this.post = false;
    this.characters = ALLOWED_CHARACTERS["xpr"];
  }
}
